import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as _ from 'lodash';

import { UnconformityService } from '../../../../../shared/service/unconformity.service';
import { UnconformityModel } from '../../../../../shared/model/unconformity.model';

@Component({
	selector: 'app-unconformity-modal',
	templateUrl: './unconformity-modal.component.html',
	styleUrls: ['./unconformity-modal.component.css']
})
export class UnconformityModalComponent implements OnInit {
	@Input() questionUnconformitites: UnconformityModel[];
	@Output() save = new EventEmitter<UnconformityModel[]>();

	display: boolean;
	unconformities: UnconformityModel[];

	source: UnconformityModel[];
	target: UnconformityModel[];

	selectedMethod = '';
	selectedOrdenation = '';

  	ascDesc = [];

	ordenation = [];

	criticalities = [];

	lastEvent: any;

	constructor(
		private unconformityService: UnconformityService,
		private translateService: TranslateService
	) {
		this.getUnconformitites();
	}

	ngOnInit() { 
		this.ascDesc = [
			{ value: 'asc', label: this.translate('asc') },
			{ value: 'desc', label: this.translate('desc') },
		];

		this.ordenation = [
		{ value: 'created_at', label:  this.translate('creation_date') },
		{ value: 'description', label: this.translate('alph_order') },
		{ value: 'criticality', label: this.translate('criticality_level') }
		];

		this.criticalities = [
			{ value: 0, label: this.translate('low_criticality') },
			{ value: 1, label: this.translate('medium_criticality') },
			{ value: 2, label: this.translate('high_criticality') },
			{ value: 3, label: this.translate('no_tolerance') }
		];

	}

	saveUnconformities() {
		this.save.emit(this.target);
	}

	onOpenModal(unconformities?) {
		if (unconformities) {
			this.questionUnconformitites = unconformities;
		}

		setTimeout(() => {
			this.buildUnconformities();
		}, 100);
	}

	onCloseModal() {
		this.source = [];
		this.target = [];
	}

	buildUnconformities() {
		this.source = [];
		this.target = [];

		let ids: number[] = [];

		this.questionUnconformitites.forEach(item => {
			ids.push(item.id);
			this.target.push(item);
		})

		this.unconformities.forEach(item => {
			if (!ids.includes(item.id)) {
				this.source.push(item);
			}
		});
	}

	getUnconformitites() {
		this.unconformities = [];
		this.unconformityService.getPaginated(0, 100000, '').subscribe(result => {
			this.unconformities = result['rows'] as UnconformityModel[];
		});
	}

  order() {
		this.target = _.orderBy(this.target, this.selectedOrdenation, this.selectedMethod);
		this.source = _.orderBy(this.source, this.selectedOrdenation, this.selectedMethod);
  }

	translate = (key: string) => this.translateService.instant(key || "invalid");
	tUpper = (key) => this.translate(key).toString().toUpperCase();
	tCap = (key) => this.translate(key).charAt(0).toUpperCase() + this.translate(key).slice(1);
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/checklist-form/question-group/question/question-form-modal/unconformity-modal/unconformity-modal.component.ts